import React from 'react';
import Reflux from 'reflux';
import {hashHistory, withRouter} from 'react-router';
import {Button, message} from 'antd';
import {DmsTab, TableView} from 'Components';
import {deliveryInvoice} from '../../service/invoiceItemMap';
import moment from 'moment';
import {objectSerial, config} from 'Utils';
import {AdvanceFormNew} from "../../components";
import {getGouXiaoUnitList} from "../../service/traceOrder";

class DeliveryInvoicelist extends Reflux.Component {
    constructor(props) {
        super(props);
        this.state = {
            opts: ['发票台账'],
            button_limits_end: JSON.parse(window.localStorage.getItem('button_limits_end')),
            rows: [],
            total: 0,
            searchObj: {
                command: '',
                itemNum: '',
                itemDesc: '',
                orderNumber: '',
                deliveryId: '',
                confirmDateBegin: '',
                confirmDateEnd: '',
                id: '',
                p: 1,
                s: 10,
                salesUnitId: ''
            },
            loading: false,
            channel_GouHuo: []
        };

        this.exportChange = this.exportChange.bind(this);
        this.pageChange = this.pageChange.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
    }

    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
    }

    componentWillMount() {
    }

    componentDidMount() {
        let channelCode = window.sessionStorage.getItem('cur_channelId');
        getGouXiaoUnitList({channelCode: channelCode, s: 999}).then(res => { //渠道
            if (res.status) {
                let arr = [];
                res.data.forEach(x => {
                    arr.push({
                        text: x.name,
                        value: x.id
                    })
                });
                this.setState({channel_GouHuo: arr},
                )
            }
        });
        //this.getData();
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    }

    //请求数据
    getData = () => {
        deliveryInvoice(this.state.searchObj).then(result => {
            if (result.status && result.code == 200) {
                this.setState({
                    rows: result.data,
                    total: result.total,
                    loading: false
                })
            } else {
                message.error(result.message);
                this.setState({loading: false});
            }
        })
    }

    //页面跳转
    goView = (url) => {
        hashHistory.push(url);
    }

    advanceSubmit = (form) => {
        if (this.state.searchObj.confirmDateEnd == "" || this.state.searchObj.confirmDateBegin == "") {
            message.info("请先选择发运日期");
            return;
        }
        if (moment(this.state.searchObj.confirmDateEnd, 'YYYY-MM-DD').diff(moment(this.state.searchObj.confirmDateBegin, 'YYYY-MM-DD'), 'days') > 180) {
            message.info("日期范围不能超过180天");
            return;
        }
        this.setState({
            searchObj: {
                ...this.state.searchObj,
                p: 1
            },
            loading: true
        }, function () {
            this.getData();
        });

    };

    advanceReset = () => {
        this.setState({
            searchObj: {
                ...this.state.searchObj,
                command: '',
                itemNum: '',
                itemDesc: '',
                orderNumber: '',
                deliveryId: '',
                confirmDateBegin: '',
                confirmDateEnd: '',
                id: '',
                p: 1,
                salesUnitId: ''
            }, loading: true
        }, () => {
            this.getData();
        });
    };

    setFilterParam(name, value) {
        if (name === 'BOOKED_DATE') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    confirmDateBegin: value.from,
                    confirmDateEnd: value.end
                }
            })
        } else {
            this.setState({searchObj: {...this.state.searchObj, [name]: value}})
        }
    };

    pageChange = (page, pageSize) => {
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}, loading: true}, function () {
            this.getData();
        });
    }

    exportChange() {
        let _searchObj = {...this.state.searchObj};
        delete _searchObj.s;
        delete _searchObj.p;
        let url = `${config.server}/api/v1/dms/tgCustItemMap/deliveryInvoiceExportExcel?${objectSerial(_searchObj)}`;
        window.open(url);
    };

    render() {
        const {
            opts,
            rows,
            total,
            searchObj,
            loading,
            channel_GouHuo
        } = this.state;

        const advanceProps = {
            fileds: [
                {
                    name: 'BOOKED_DATE',//orderedDateBegin, orderedDateEnd
                    label: '发运日期',
                    options: [
                        {text: '开始时间'},
                        {text: '结束时间'},
                    ],
                    type: 'dateComp',
                    defaultValue: {
                        from: searchObj.confirmDateBegin || '',
                        end: searchObj.confirmDateEnd || ''
                    },
                },
                {
                    name: 'orderNumber',
                    label: '订单编号',
                    text: '输入订单编号',
                    type: 'default',
                    defaultValue: searchObj.orderNumber
                },
                {
                    name: 'deliveryId',
                    label: '出库单号',
                    text: '输入出库单号',
                    type: 'default',
                    defaultValue: searchObj.deliveryId
                },
                {
                    name: 'itemNum',
                    label: '物料编码',
                    text: '输入物料编码',
                    type: 'default',
                    defaultValue: searchObj.itemNum
                },
                {
                    name: 'itemDesc',
                    label: '物料描述',
                    text: '输入物料描述',
                    type: 'default',
                    defaultValue: searchObj.itemDesc
                },
                {
                    name: 'salesUnitId',
                    label: '购货单位',
                    text: '输入购货单位',
                    type: 'select',
                    defaultValue: searchObj.salesUnitId,
                    allowClear: true,
                    showSearch: true,
                    options: channel_GouHuo,
                },
                {
                    name: 'command',
                    label: '结算对应号',
                    text: '输入结算对应号',
                    type: 'default',
                    defaultValue: searchObj.command
                }
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };

        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: total,
                current: this.state.searchObj.p,//当前页码
                pageSize: this.state.searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '购货单位',
                    dataIndex: 'SALES_UNIT_NAME'
                },
                {
                    title: '订单编号',
                    dataIndex: 'ORDER_NUMBER'
                },
                {
                    title: '物料编码',
                    dataIndex: 'ITEM_NUM'
                },
                {
                    title: '物料描述',
                    dataIndex: 'ITEM_DESC'
                },
                {
                    title: '客户物料编码',
                    dataIndex: 'CUST_ITEM_NUM'
                },
                {
                    title: '客户物料描述',
                    dataIndex: 'CUST_ITEM_DESC'
                },
                {
                    title: '客户物料类别',
                    dataIndex: 'CUST_ITEM_TYPE'
                },
                {
                    title: '客户物料单位',
                    dataIndex: 'CUST_ITEM_UNIT'
                },
                {
                    title: '订单数量',
                    dataIndex: 'ORDERED_QUANTITY'
                },
                {
                    title: '不含税单价',
                    dataIndex: 'PRICE_WITHOUT_TAX'
                },
                {
                    title: '税率',
                    dataIndex: 'TAX_CODE'
                },
                {
                    title: '不含税金额',
                    dataIndex: 'AMOUNT_WITHOUT_TAX'
                },
                {
                    title: '发票池ID',
                    dataIndex: 'LINE_ID'
                },
                {
                    title: '结算对应号',
                    dataIndex: 'SETTLEMENT'
                },
                {
                    title: '行备注',
                    dataIndex: 'LINE_REMARK'
                },
                {
                    title: '头备注',
                    dataIndex: 'REMARK'
                },
                {
                    title: '登记日期',
                    dataIndex: 'BOOKED_DATE',
                    render: (text, record) => {
                        return moment(Number(text)).format('YYYY-MM-DD')
                    }
                },
                {
                    title: '发运日期',
                    dataIndex: 'CR_DATE',
                    render: (text, record) => {
                        return moment(Number(text)).format('YYYY-MM-DD')
                    }
                },
                {
                    title: '出库单号',
                    dataIndex: 'DELIVERY_ID'
                },
                {
                    title: '出库数量',
                    dataIndex: 'DELIVERY_QUANTITY'
                },
                {
                    title: '未开数量',
                    dataIndex: 'RES_QUANTITY'
                },
                {
                    title: '提交号',
                    dataIndex: 'INVOICE_ORDER_NUMBER'
                },
                {
                    title: '开票日期',
                    dataIndex: 'PRINT_DATE'
                },
                {
                    title: '开票数量',
                    dataIndex: 'INVOIECE_QUANTITY'
                },
                {
                    title: '发票号',
                    dataIndex: 'INVOICE_NUMBER'
                }
            ],
            rows: rows
        };


        return (
            <div className='dms-body'>
                <div>
                    <DmsTab options={opts} defaultKey={0}>
                        <Button icon="export" onClick={this.exportChange}>导出</Button>
                    </DmsTab>
                </div>
                <div className="advanceForm-box">
                    <div className="advanceForm-content">
                        <AdvanceFormNew {...advanceProps}/>
                    </div>
                </div>
                <div className="dms-table-box">
                    <TableView {...tableViewProps} />
                </div>
            </div>
        )
    }
};
export default withRouter(DeliveryInvoicelist);




// WEBPACK FOOTER //
// ./src/routes/invoiceItemMap/deliveryInvoicelist.js